import { useEffect, useState } from "react";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';


export default function CheckForm() {

    const tabs = [
        { name: 'Embarkation Ladder', type: "embed_ladder_contracts" },
        { name: 'Pilot Ladder', type: "pilot_ladder_contracts" }
    ]

    // const { executeRecaptcha } = useGoogleReCaptcha();
    const [status, setStatus] = useState('');


    const today = new Date();
    const thisYear = today.getFullYear();
    const [month, setMonth] = useState(String(new Date().getMonth() + 1).padStart(2, "0"));

    const [year, setYear] = useState(thisYear);

    const [date, setDate] = useState(`${thisYear}-${month}`); // YYYY-MM format
    const [serialNumber, setSerialNumber] = useState("");
    const [meter, setMeter] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [responseMessage, setResponseMessage] = useState(null);
    const [foundedCertificate, setFoundedCertificate] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const onClose = () => {
        setShowPopup(false);
        setFoundedCertificate(false);
        setResponseMessage(null);
    }


    const [selectedType, setSelectedType] = useState(
        tabs[0].type
    );

    function onChange(value) {
        console.log("Captcha value:", value);
    }


    const handleChange = (e) => {
        setSelectedType(e.target.value);
    };


    useEffect(() => {
        const formattedDate = `${year}-${month}`;
        setDate(formattedDate);
    }, [year, month]);

    useEffect(() => {
        date.split("-").length === 2 && setYear(date.split("-")[0]);
        setYear(date.split("-")[0]);
    }, [date]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // if (!executeRecaptcha) {
        //     setStatus("Recaptcha yüklenemedi.");
        //     return;
        // }

        // const token = await executeRecaptcha("form_submit");

        if (!date || !serialNumber || !meter) {
            setError("Lütfen tüm alanları doldurun.");
            return;
        }

        setError("");
        setLoading(true);
        setResponseMessage(null);

        try {

            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/check`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    date,
                    // token: token,
                    serial_number: `${year}-${serialNumber}`,
                    meter: `${meter} MT`,
                    selectedType: selectedType
                }),
            });

            const contract = await response.json();

            if (!response.ok) {
                throw new Error(`Sunucu hatası: ${response.status}`);
            }
            setShowPopup(true);
            if (contract.certificate) {
                setFoundedCertificate(contract.data);
            } else {
                setFoundedCertificate(false);
            }
            const data = await response.json();

            setResponseMessage(data.message || "İşlem başarıyla tamamlandı.");
        } catch (err) {
            setResponseMessage(`Hata: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-10 p-6 bg-white rounded-2xl shadow-lg">

            {showPopup && (foundedCertificate ? <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="bg-white rounded-xl p-6 w-96 shadow-lg text-center">
                    <h2 className="text-xl font-semibold text-green-600 mb-4">Certificate Found</h2>
                    <p className="mb-6 text-gray-700">The certificate was successfully found in the system.</p>
                    <div className="flex justify-center gap-4">
                        <a
                            href={foundedCertificate.url}
                            download
                            target="_blank"
                            className="cursor-pointer bg-indigo-600 text-white px-4 py-2 rounded-xl hover:bg-indigo-700 transition"
                        >
                            Download
                        </a>
                        <button
                            onClick={onClose}
                            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-xl hover:bg-gray-400 transition"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div> : <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center z-50">
                <div className="bg-white rounded-xl p-6 w-96 shadow-lg text-center">
                    <h2 className="text-xl font-semibold text-red-600 mb-4">❌ Certificate Not Found</h2>
                    <p className="mb-6 text-gray-700">No certificate matching the entered information was found.</p>
                    <button
                        onClick={onClose}
                        className="bg-red-500 text-white px-4 py-2 rounded-xl hover:bg-red-600 transition"
                    >
                        Close
                    </button>
                </div>
            </div>)}

            <h2 className="text-2xl font-bold mb-4 text-center">Certificate Check</h2>
            {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
            <form onSubmit={handleSubmit} className="space-y-4">
                <select
                    id="font-select"
                    value={selectedType}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
                >
                    <option key="null" value="" disabled>
                        Select Ladder Type
                    </option>
                    {tabs.map(tab => (
                        <option key={tab.type} value={tab.type}>
                            {tab.name}
                        </option>
                    ))}
                </select>
                <div className="flex gap-4">
                    {/* Yıl inputu */}
                    <div className="flex flex-col">
                        <label className="mb-1 font-medium">Year</label>
                        <input
                            type="number"
                            value={year}
                            onChange={(e) => setYear(e.target.value)}
                            className="w-32 h-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
                            min="1900"
                            max="2100"
                        />
                    </div>

                    {/* Ay select */}
                    <div className="flex flex-col">
                        <label className="mb-1 font-medium">Month</label>
                        <select
                            value={month}
                            onChange={(e) => setMonth(e.target.value)}
                            className="w-32 h-full px-4 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        >
                            {Array.from({ length: 12 }, (_, i) => {
                                const val = String(i + 1).padStart(2, "0");
                                return (
                                    <option key={val} value={val}>
                                        {val}
                                    </option>
                                );
                            })}
                        </select>
                    </div>
                </div>
                <div>
                    <label className="block mb-1 font-medium">Serial Number</label>
                    <div className="flex">
                        <span className="inline-flex items-center px-3 rounded-l-xl border border-r-0 border-gray-300 bg-gray-100 select-none">
                            {year}-
                        </span>
                        <input
                            type="text"
                            value={serialNumber}
                            onChange={(e) => {
                                const val = e.target.value;
                                setSerialNumber(val);
                            }}
                            className="w-full px-4 py-2 border rounded-r-xl border-l-0 focus:outline-none focus:ring-2 focus:ring-indigo-400"
                            placeholder=""
                        />
                    </div>
                </div>

                <div className="flex items-center w-[50%]">
                    <input
                        type="number"
                        value={meter}
                        onChange={(e) => setMeter(e.target.value)}
                        className="flex-grow w-full px-4 py-2 border rounded-l-xl focus:outline-none focus:ring-2 focus:ring-indigo-400"
                        placeholder="1250"
                    />
                    <span className="flex-grow px-4 py-2 border rounded-r-xl focus:outline-none focus:ring-2 border-gray-300 bg-gray-100 focus:ring-indigo-400 select-none">
                        Mt.
                    </span>
                </div>
                <button
                    type="submit"
                    className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-xl transition"
                >
                    Check Certificate
                </button>
            </form>

        </div >
    );
}